// extracted by mini-css-extract-plugin
module.exports = {"root":"EABD2CaseContactUs_root__2eK1u","textWrapper":"EABD2CaseContactUs_textWrapper__2PZFP","text":"EABD2CaseContactUs_text__2elgM"};